export const GET_ADVERTISORS = 'GET_ADVERTISOR'
export const RECEIVED_ADVERTISOR = 'RECEIVED_ADVERTISOR'


